<button
  class="row-button"
  [class.selected-row-button]="isSelected"
  (click)="onButtonClick()"
  [class.task-item-variable-bg]="!newTask"
>
  <input
    #inputElement
    type="number"
    min="1"
    step="1"
    [value]="inputControl?.value"
    (input)="onInputChange($any($event.target).value)"
    (blur)="onInputBlur()"
  />
  <div class="button-divider" [class.selected-button-divider]="isSelected"></div>
  <div class="tasks-text">{{ rightContainerText }}</div>
</button>
